import React, { useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import { CheckSquare, Square } from 'react-feather';
import PropTypes from 'prop-types';
import Table from '../ui/Table';
import { EMAIL_GROUPS } from '../../helpers/constants';

const selectEmailsByGroups = (grupo, alumno) => {
  const emailsSelectedes = grupo.map((g) => {
    let emailToSelect = '';

    switch (g.value) {
      case EMAIL_GROUPS.PERSONAL:
        emailToSelect = alumno.Email_personal;
        break;
      case EMAIL_GROUPS.CENTRO:
        emailToSelect = alumno.Email_Cedetec;
        break;
      case EMAIL_GROUPS.TUTOR1:
        emailToSelect = alumno.Tutor1_Mail;
        break;
      case EMAIL_GROUPS.TUTOR2:
        emailToSelect = alumno.Tutor2_Mail;
        break;
      default:
        break;
    }

    return emailToSelect === '-' ? '' : emailToSelect || '';
  });

  return emailsSelectedes;
};

const CheckboxAlumnoCell = ({ original, selectedEmails, grupo, onCheckboxChange }) => {
  if (!original.CODIGO) return null;
  const key = String(original.CODIGO);
  const checked = Object.prototype.hasOwnProperty.call(selectedEmails, key);
  const emails = selectEmailsByGroups(grupo, original);
  return (
    <Input
      type="checkbox"
      checked={checked}
      onChange={() => onCheckboxChange(key, emails)}
    />
  );
};
CheckboxAlumnoCell.propTypes = {
  original: PropTypes.shape({ CODIGO: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
    .isRequired,
  selectedEmails: PropTypes.object.isRequired,
  grupo: PropTypes.array.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
};

const ListadoAlumnos = ({ alumnos, grupo, selectedEmails, setSelectedEmails }) => {
  useEffect(() => {
    if (!alumnos || alumnos.length === 0) {
      setSelectedEmails({});
      return;
    }

    setSelectedEmails((prevSelectedEmails) => {
      const newSelectedEmails = {};
      const alumnosSelecteds = alumnos.filter((a) =>
        Object.keys(prevSelectedEmails).includes(String(a.CODIGO)),
      );

      alumnosSelecteds.forEach((alumno) => {
        const emailsSelectedes = selectEmailsByGroups(grupo, alumno);
        newSelectedEmails[alumno.CODIGO] = emailsSelectedes;
      });

      return newSelectedEmails;
    });
  }, [alumnos, grupo, setSelectedEmails]);

  const [allSelected, setAllSelected] = useState(false);

  const handleCheckboxChange = (codigo, email) => {
    const key = String(codigo);
    const updatedEmails = { ...selectedEmails };
    if (Object.prototype.hasOwnProperty.call(updatedEmails, key)) {
      delete updatedEmails[key];
    } else {
      updatedEmails[key] = email;
    }
    setSelectedEmails(updatedEmails);
  };

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedEmails({});
    } else {
      const allEmails = {};
      alumnos.forEach((alumno) => {
        if (!alumno.CODIGO) return;
        const emailsSelectedes = selectEmailsByGroups(grupo, alumno);
        allEmails[String(alumno.CODIGO)] = emailsSelectedes;
      });
      setSelectedEmails(allEmails);
    }
    setAllSelected(!allSelected);
  };

  const columns = [
    {
      Header: 'Seleccionar',
      accessor: 'actions',
      CellComponent: CheckboxAlumnoCell,
      cellProps: {
        selectedEmails,
        grupo,
        onCheckboxChange: handleCheckboxChange,
      },
      sortable: false,
    },
    {
      Header: 'Código',
      accessor: 'CODIGO',
    },
    {
      Header: 'Sede',
      accessor: 'SEDE',
    },
    {
      Header: 'Nombre',
      accessor: 'NOMBRE_ALUMNO',
    },
    {
      Header: 'Apellidos',
      accessor: 'APELLIDOS',
    },
    {
      Header: 'Email Cedetec',
      accessor: 'Email_Cedetec',
    },
    {
      Header: 'Email Personal',
      accessor: 'Email_personal',
    },
    {
      Header: 'Tutor 1 Email',
      accessor: 'Tutor1_Mail',
    },
    {
      Header: 'Tutor 2 Email',
      accessor: 'Tutor2_Mail',
    },
    {
      Header: 'DNI',
      accessor: 'DNI',
    },
  ];

  return (
    <>
      {alumnos.length > 0 ? (
        <>
          <button
            type="button"
            onClick={toggleSelectAll}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px',
              fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
              border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#6b7280',
              cursor: 'pointer', transition: 'all 0.15s', marginBottom: '8px',
            }}
          >
            {allSelected ? <Square size={13} /> : <CheckSquare size={13} />}
            {allSelected ? 'Desmarcar Todo' : 'Marcar Todo'}
          </button>
          <Table
            columns={columns}
            data={alumnos}
            defaultPageSize={10}
            showPaginationBottom
            className="-striped -highlight mt-5 text-center"
          />
        </>
      ) : (
        ''
      )}
    </>
  );
};

ListadoAlumnos.propTypes = {
  alumnos: PropTypes.array.isRequired,
  grupo: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })).isRequired,
  selectedEmails: PropTypes.object,
  setSelectedEmails: PropTypes.func,
};

export default ListadoAlumnos;
